import { styled } from '@mui/material'

import { StyledControlInputLarge } from '../../styles/Control'

export const Max = styled('div')`
  line-height: 24px;
  color: ${(props) => props.theme.color.text90};
  padding: 0 12px;
  cursor: pointer;
  background: ${(props) => props.theme.color.primary10};
  border-radius: 2px;
`
export const Available = styled('div')`
  display: flex;
  justify-content: space-between;
  text-align: right;
  font-size: 16px;
  line-height: 16px;
  span {
    color: #76809d;
  }
  b {
    color: #303648;
    font-weight: 500;
  }
`

export const GrayBgContent = styled('div')`
  background-color: rgba(42, 49, 57, 1);
  font-size: 12px;

  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  padding: 12px;
  strong {
  }
`
export const HeaderTip = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  color: ${(props) => props.theme.color.text70};
`
export const ReceiveWrap = styled('div')`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  line-height: 24px;

  .left {
    color: rgba(229, 234, 238, 1);
  }
  .right {
    font-weight: 600;
    text-align: right;
    color: rgba(255, 255, 255, 1);
  }
`
export const FeeWrap = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: ${(props) => props.theme.color.text70};
`
export const SelectTokenAndNetworkWrap = styled(StyledControlInputLarge)`
  justify-content: space-between;
  height: 64px;
  padding-left: 0;
  padding-right: 0;
  background: ${(props) => props.theme.color.bg};
`
